import { Button } from '../ui/button';

export const TYPES_FINANCEMENT = ['CPF', 'France Travail', 'Région', 'OPCO', 'Transition Pro', 'AGEFIPH', 'Autre'];

export const TypeFinancementPicker = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap gap-1" data-testid={testId}>
    {TYPES_FINANCEMENT.map(t => (
      <Button key={t} type="button" size="sm" variant={value === t ? 'default' : 'outline'} className="h-7 px-2 text-xs"
        onClick={() => onChange(t)} data-testid={`${testId}-${t.toLowerCase().replace(/\s+/g, '-')}`}>
        {t}
      </Button>
    ))}
  </div>
);
